import PropTypes from 'prop-types';

import Avatar from '@zenbusiness/zui/Avatar';
import Card from '@zenbusiness/zui/Card';
import Link from '@zenbusiness/zui/Link';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import { getNameInitials } from '#client/utils/formatString';

import * as Styled from './BusinessEntityCard.styles';

function BusinessEntityCard({ uuid, name }) {
  const theme = useTheme();

  return (
    <Card component={Link} to={`/dashboard/${uuid}`}>
      <Styled.CardContent>
        <Avatar
          alt={name}
          variant="square"
          sx={{
            borderRadius: theme.shape.rounded.md,
            width: 48,
            height: 48
          }}
        >
          <Text size="xl" color="white" weight="medium">
            {getNameInitials(name)}
          </Text>
        </Avatar>
        <Text size="lg" color="primary" weight="medium" width="100%">
          {name}
        </Text>
      </Styled.CardContent>
    </Card>
  );
}

BusinessEntityCard.propTypes = {
  uuid: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};

export default BusinessEntityCard;
